module.exports = __webpack_public_path__ + "img/exa1.6cd916a9.png";